import { useContext } from 'react';
import { GlobalContext } from '../context/globalContext';

const useGlobal = () => {
    const [state, setState] = useContext(GlobalContext);

    const setCantidadReservas = (count) => {
        setState(state => ({ ...state, cantidadReservas: count }));
    }

    const setUsuario = (usuario) => {
        setState(state => ({ ...state, usuario }));
    }

    return {
        setCantidadReservas,
        cantidadReservas: state.cantidadReservas,
        usuario: state.usuario,
        setUsuario
    };
};

export default useGlobal;


// WEBPACK FOOTER //
// ./src/utils/useGlobal.js